const NUM_BUCKETS = 10;

const formatUserGroup = (value: number) => {
  return `user_group-${value}`;
};

export const getGroupIdFromUserGroup = (group: string) => {
  try {
    const groupId = parseInt(group.replace('user_group-', ''), 10);

    if (isNaN(groupId) || groupId < 1 || groupId > NUM_BUCKETS) {
      throw new Error('Invalid group id');
    }

    return `${groupId}`;
  } catch (error) {
    console.error(error);
  }

  return '1';
};

const genRandomUserGroupId = () => {
  return formatUserGroup(Math.floor(Math.random() * NUM_BUCKETS) + 1);
};

export const getUserGroup = (initialValue?: string, userId?: string) => {
  let groupId;
  if (userId) {
    groupId = formatUserGroup(hashUUIDToBucket(userId));
  } else if (initialValue) {
    groupId = initialValue;
  } else {
    groupId = genRandomUserGroupId();
  }
  return groupId;
};

/**
 * Synchronously assigns a UUID to a consistent group (1 to NUM_BUCKETS).
 * Uses a simple hash function to ensure deterministic distribution.
 *
 * @param uuid - The UUID string to assign to a group
 * @returns A number between 1 and NUM_BUCKETS representing the assigned group
 */
export const hashUUIDToBucket = (uuid: string): number => {
  // Simple hash function (djb2 variant) for synchronous hashing
  let hash = 5381;
  for (let i = 0; i < uuid.length; i++) {
    hash = (hash << 5) + hash + (uuid.codePointAt(i) ?? 0);
    hash = Math.trunc(hash); // Convert to 32-bit signed integer
  }

  // Ensure positive number and distribute across buckets
  return (Math.abs(hash) % NUM_BUCKETS) + 1;
};
